import { render, staticRenderFns } from "./foodEditDescription.vue?vue&type=template&id=57e89ed7&scoped=true"
import script from "./foodEditDescription.vue?vue&type=script&lang=js"
export * from "./foodEditDescription.vue?vue&type=script&lang=js"
import style0 from "./foodEditDescription.vue?vue&type=style&index=0&id=57e89ed7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e89ed7",
  null
  
)

export default component.exports